import { motion } from 'framer-motion';

const SecurityBadge = () => {
  return (
    <motion.div 
      layout
      transition={{
        layout: { type: "spring", stiffness: 300, damping: 30 }
      }}
      className="mt-6 flex items-center justify-center"
    >
      <div className="flex items-center text-[#8a7266] bg-[#f9f6f4] px-3 py-1.5 rounded-full text-xs shadow-sm">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-1.5">
          <path d="M19 11H5V21H19V11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M17 9V8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8V9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        Secure Connection
      </div>
    </motion.div>
  );
};

export default SecurityBadge;